import { Select } from '@mantine/core'

import { HiringStage } from 'src/graphql/types/applicants'
import { formatSnakeValue } from 'src/lib/formatters'

import { inlineSelectProps } from './inlineSelectStyles'

const HiringStageOptions = ({
  selectedHiringStage,
  setSelectedHiringStage,
}) => {
  const hiringStageOptions = Object.values(HiringStage).map((stage) => ({
    value: stage,
    label: formatSnakeValue(stage),
  }))

  return (
    <div className="flex flex-col gap-2 text-xs">      <Select
        {...inlineSelectProps}
        value={selectedHiringStage?.hiringStage}
        onChange={(value) => setSelectedHiringStage({ hiringStage: value })}
        data={hiringStageOptions}
        placeholder="Select hiring stage"
        className="max-w-sm"
        searchable
      />
    </div>
  )
}

export default HiringStageOptions
